define.alias("shared/components/shared/stop-the-world-modal", "settings/components/shared/stop-the-world-modal");